module.exports = __webpack_public_path__ + "img/9.96f7d948.svg";